import script from "./MaisonetteSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./MaisonetteSlider.vue?vue&type=script&setup=true&lang=js"

import "./MaisonetteSlider.vue?vue&type=style&index=0&id=148ef948&lang=css"

const __exports__ = script;

export default __exports__